import React from "react";
import { useParams } from "react-router-dom";
import db from "../../firebase";  
import { useCollectionData } from "react-firebase-hooks/firestore";

const Author = (props) => {
    const { name } = useParams();
    const authorsRef = db.collection("authors");
    const query = authorsRef.where("name", "==", name);
    const [author, loading, error] = useCollectionData(query);
    return (
        <div>
            {loading && <h1>Loading...</h1>}
            {error && <h1>{error}</h1>}
            <h1>{name}</h1>
            <h2>{author && author[0].name} is a {author && author[0].designation} at {author && author[0].institution}</h2>
        </div>
    );
}

export default Author;